(function () {
    'use strict';

    angular
        .module('blocks.smart')
        .directive('smartResetFilter', smartResetFilter);

    /* @ngInject */
    function smartResetFilter() {
        // allows us to have a date filter on smart tables.
        // Usage:
        //  <smart-date predicate="someDateField"></smart-select>
        // Creates:
        //  <smart-select predicate="someDateField">
        //  <input><input>
        //  </smart-select>
        var directive = {
            restrict: 'EA',
            require: '^stTable',
            link: link
        };
        return directive;

        function link(scope, element, attr, table) {
            return element.bind('click', function () {
                return scope.$apply(function () {
                    var tableState = table.tableState();
                    tableState.search.predicateObject = {};
                    tableState.pagination.start = 0;
                    return table.pipe();
                });
            });
        }
    }
})();
